"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roles_container_1 = require("./roles-container");
var UserRolesContainer = /** @class */ (function () {
    function UserRolesContainer() {
        this.userRoles = [];
        this.userRoleDict = {};
        if (UserRolesContainer.instance) {
            return UserRolesContainer.instance;
        }
        UserRolesContainer.instance = this;
    }
    UserRolesContainer.prototype.setUserRoles = function (userRoles) {
        this.userRoles = [];
        this.userRoleDict = {};
        var roleRepo = new roles_container_1.RolesContainer();
        for (var _i = 0, userRoles_1 = userRoles; _i < userRoles_1.length; _i++) {
            var userRole = userRoles_1[_i];
            this.addUserRole({
                userId: userRole.id,
                context: userRole.context,
                role: roleRepo.getRole(userRole.role)
            });
        }
    };
    UserRolesContainer.prototype.setUser = function (_a) {
        var id = _a.id, roles = _a.roles;
        var roleRepo = new roles_container_1.RolesContainer();
        var userRoles = roles.map(function (role) { return ({
            id: id,
            role: role.role,
            context: role.context
        }); });
        for (var _i = 0, userRoles_2 = userRoles; _i < userRoles_2.length; _i++) {
            var userRole = userRoles_2[_i];
            this.addUserRole({
                userId: userRole.id,
                context: userRole.context,
                role: roleRepo.getRole(userRole.role)
            });
        }
    };
    UserRolesContainer.prototype.addUserRole = function (userRole) {
        if (!this.validateUserRole(userRole)) {
            throw Error("User role is invalid");
        }
        this.userRoles.push(userRole);
        var userId = userRole.userId, role = userRole.role, context = userRole.context;
        if (!this.userRoleDict[userId]) {
            this.userRoleDict[userId] = {
                contextBound: {
                    roles: [],
                    permissions: []
                },
                contextFree: {
                    roles: [],
                    permissions: []
                },
            };
        }
        ;
        if (context) {
            var contextBound = this.userRoleDict[userId].contextBound;
            contextBound.roles.push(userRole);
            var _loop_1 = function (permission) {
                var currentPermission = contextBound.permissions.find(function (p) { return p.name === permission.name; });
                if (!currentPermission) {
                    contextBound.permissions.push({ name: permission.name, contexts: [context] });
                }
                else {
                    if (!currentPermission.contexts.find(function (ctx) { return ctx.id === context.id && ctx.type === context.type; })) {
                        currentPermission.contexts.push(context);
                    }
                }
            };
            for (var _i = 0, _a = role.permissions; _i < _a.length; _i++) {
                var permission = _a[_i];
                _loop_1(permission);
            }
        }
        else {
            var contextFree = this.userRoleDict[userId].contextFree;
            contextFree.roles.push(role);
            var _loop_2 = function (permission) {
                if (!contextFree.permissions.find(function (p) { return p.name === permission.name; })) {
                    contextFree.permissions.push(permission);
                }
            };
            for (var _b = 0, _c = role.permissions; _b < _c.length; _b++) {
                var permission = _c[_b];
                _loop_2(permission);
            }
        }
    };
    UserRolesContainer.prototype.validateUserRole = function (userRole) {
        if (!userRole) {
            return false;
        }
        if (!userRole.role) {
            return false;
        }
        var roleRepo = new roles_container_1.RolesContainer();
        return roleRepo.validateRole(userRole.role);
    };
    UserRolesContainer.prototype.getRolesForUser = function (userId) {
        return this.userRoleDict[userId];
    };
    return UserRolesContainer;
}());
exports.UserRolesContainer = UserRolesContainer;
//# sourceMappingURL=user-roles-container.js.map